<template>
  <div class="coupons">
    <van-tabs v-model="active"
              sticky
              color="#388BFF"
              titleActiveColor="#388BFF"
              @change="changeTab" >
      <van-tab title="Available" name="Available">
          <div v-if="availableItems.length > 0" class="list">
            <van-card
              v-for="item in availableItems" :key="item.voucherTransferId"
              @click="onCouponTap(item.voucherId, item.voucherTransferId, item.memberId)"
              :title="item.goodsItemName"
              :thumb="item.goodsItemUrlIco"
            >
              <!-- <template #tags>
                <p class="tips gray">Expiry Date: {{item.verifyTimeEnd | dateFormat('day', '/')}}</p>
              </template> -->
            </van-card>
          </div>
        <data-nothing v-if="!isloading && availableItems.length < 1" type="coupons"></data-nothing>
      </van-tab>
      <van-tab title="Unavailable" name="Unavailable">
          <div v-if="unavailableItems.length > 0" class="list disabled">
            <van-card
              v-for="item in unavailableItems" :key="item.voucherTransferId"
              :title="item.goodsItemName"
              :desc="item.brandName"
              :thumb="item.goodsItemUrlIco"
            >
              <template #tags>
                <div class="fx fx-between" v-if="(item.voucherStatus === 'Init' || item.voucherStatus === 'Using') && item.verifyTimeEnd < today">
                  <!-- <p class="tips gray">Expiry Date: {{item.verifyTimeEnd | dateFormat('day', '/')}}</p> -->
                  <img class="status-img" src="../../assets/img/coupons_expired.png" alt="">
                </div>
                <div class="fx fx-between" v-else>
                  <p class="tips gray">Giving time: {{item.updateDate | dateFormat('minute', '/')}}</p>
                  <img v-if="item.voucherStatus === 'Transferred'" class="status-img" src="../../assets/img/coupons_gifted.png" alt="">
                  <img v-if="item.voucherStatus === 'Using' || item.voucherStatus === 'Verified'" class="status-img" src="../../assets/img/coupons_used.png" alt="">
                </div>
              </template>
            </van-card>
          </div>
        <data-nothing v-if="!isloading && unavailableItems.length < 1" type="coupons"></data-nothing>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
export default {
  data () {
    return {
      active: 'Available',
      voucherParams: {
        token: '',
        pageNumber: 1,
        pageSize: 500,
        condition: {
          groupStatus: 'Available'
        }
      },
      totalPage: 0,
      availableItems: [],
      unavailableItems: [],
      isloading: true
    }
  },
  filters: {
    status (s) {
      switch (s) {
        case 'Paid':
          return 'In Processing'
        case 'Complete':
          return 'Not Gifted'
        case 'Transferred':
          return 'Gifted'
        case 'Refund':
          return 'Refund'
        case 'Cancel':
          return 'Transaction Close'
        case 'Init':
          return 'To Pay'
        case 'Invalid':
          return 'Payment Timeout'
        default:
          return status
      }
    }
  },
  created () {
    this.$cux.loading()
    let token = this.$util.storageGet('local', 'token')
    if (token) {
      this.voucherParams.token = token
      this.loadData()
    } else {
      this.availableItems = []
      this.unavailableItems = []
    }
  },
  methods: {
    // 获取券列表 可用
    getMyCardPackage (params) {
      return this.$http.post('/olvp/getMyCardPackage', 'getMyCardPackage', params, false, false, false, false)
    },
    changeTab (e) {
      this.availableItems = []
      this.unavailableItems = []
      this.voucherParams.pageNumber = 1
      this.voucherParams.condition.groupStatus = e
      this.isloading = true
      this.loadData()
    },
    loadData () {
      return new Promise(resolve => {
        this.getMyCardPackage(this.voucherParams).then((d) => {
          this.$cux.loadend()
          if (d.success) {
            const data = d.content
            this.totalPage = Math.ceil(data.totalSize / data.pageSize)
            if (this.voucherParams.condition.groupStatus === 'Available') {
              this.availableItems = data.dataList
            } else {
              this.unavailableItems = data.dataList
            }
          }
          this.isloading = false
          resolve()
        })
      })
    },
    // 查看券
    onCouponTap (id, tid, mid) {
      const voucherId = id || tid
      this.$router.push(`/couponDetail?voucherId=${voucherId}&memberId=${mid}&type=voucher`)
    },
    goBack () {
      this.$router.replace('home')
    }
  }
}
</script>

<style lang="scss">
  .coupons {
    width: 100%;
    height: 100%;
    .van-card {
      font-size: 14px;
      padding: 15px 0;
      background-color: #fff;
      border-bottom: 1px dashed #ccc;
      &:not(:first-child) {
        margin-top: 1px;
      }
    }
    .van-card__title {
      font-size: 17px;
      margin-top: 5px;
      margin-bottom: 5px;
    }
    .van-card__thumb {
      width: 70px;
      height: 70px;
    }
    .van-card__content {
      min-height: 70px;
    }

    .van-loading {
      text-align: center
    }

    .title {
      padding: 15px 20px 8px 20px;
      border-bottom: 1px solid #f5f5f5;
      font-size: 16px;
      .h-ico {
        width: 25px;
        height: 25px;
        margin-left: 15px;
      }
      .blue {
        font-size: 12px;
        text-decoration: underline;
        margin-left: 5px;
      }
    }

    .nothing {
      padding: 50px 0;
      text-align: center;
    }

    .list {
      padding: 0px 15px 100px 15px;
      .item {
        border-bottom: 1px dashed #ccc;

        .coupons-logo {
          width: 55px;
          height: 55px;
          margin-right: 12px;
          border-radius: 5px;
        }

        .name {
          font-size: 17px;
          margin-bottom: 4px
        }

        .tips {
          font-size: 14px;
        }
      }
    }
    // .list.disabled {
    //   padding: 0;
    //   .van-card {
    //     background: #f5f5f5;
    //     padding: 15px;
    //   }
    // }
    .van-multi-ellipsis--l2, .van-multi-ellipsis--l3 {
      overflow: visible !important;
    }
    .status-img {
      width: 50px;
      height: 50px;
      position: absolute;
      right: 0;
      bottom: 0;
    }
  }
</style>
